export const CONFERMATO = 'confermato';
export const SALVATO = 'salvato';
